var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"account-score"},[(_vm.loading)?_c('span',{staticClass:"loading"},[_c('i',{staticClass:"el-icon-loading"})]):(_vm.score !== null)?_c('span',{staticClass:"score-value"},[_vm._v(" 机会分数:"+_vm._s(_vm.score)+" ")]):_c('span',{staticClass:"score-placeholder"},[_vm._v("--")])])
}
var staticRenderFns = []

export { render, staticRenderFns }